import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-idaho-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./idaho-state-form.component.html",
  styleUrl: "./idaho-state-form.component.scss",
})
export class IdahoStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
